<p>metric-progress-by-region-chart works!</p>
